import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import AccountForm from './AccountForm';
import AccountApiContext from './contexts/AccountApiContext';
import { getAccount, createTransaction } from './utils';
import ErrorContext from '../../ErrorBoundary/contexts/ErrorContext';

const AccountPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: -8vh;
    height: 90vh;
    padding: 30px;
`;

class Accounts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transactionData: {},
            accountData: {},
            isSubmitted: false,
            errMsg: ''
        }
    }

    updateTransaction = (transRes) => {
        this.setState({
            isSubmitted: true,
            transactionData: transRes
        });
    }

    updateAccount = (acctRes) => {
        this.setState({
            accountData: acctRes
        });
    }

    renderError = (err) => {
        this.setState({ errMsg: err });
    }

    render() {
        const { isSubmitted } = this.state;

        return (
            <ErrorContext.Consumer>
                {errorValue => (
                    <AccountPageContainer
                        isSubmitted={isSubmitted}
                    >
                        <AccountApiContext.Provider
                            value={{ ...this.state, getAccount, createTransaction, updateTransaction: this.updateTransaction }}
                        >
                            <AccountForm
                                errorValue={errorValue}
                                transactionData={this.state.transactionData}
                                createTransaction={createTransaction}
                                getAccount={getAccount}
                                updateTransaction={this.updateTransaction}
                                updateAccount={this.updateAccount}
                                renderError={this.renderError}
                            />
                        </AccountApiContext.Provider>
                    </AccountPageContainer>
                )}
            </ErrorContext.Consumer>
        )
    }
}

export default Accounts;